import { useContext, useEffect } from 'react'
import { AxiosBackend } from './AxiosInstance'
import { NotificationType } from '../../Context/GlobalNotification/Types'
import { GlobalNotificationContext } from '../../Context/GlobalNotification/GlobalNotificationProvider'
import { CookieService } from '../CookieStorageService'
import { GlobalLoaderContext } from '../../Context/GlobalLoader/GlobalLoader'
import { isErrorWithViewMessage } from '../../Guards/errorWithViewMessage'
import { isErrorWithResponse } from '../../Guards/errorWithResponse'
import { isResponseWithToken } from '../../Guards/responseWithToken'
import { parseJwt } from '../../helpers/http'
import { UserDtoToFrontAdapter } from '../../helpers/adapters/user'
import { UserContext } from '../../Context/User/UserContext'

export const useAxiosInterceptors = () => {
  const userContext = useContext(UserContext)
  const showNotification = useContext(GlobalNotificationContext)
  const showLoader = useContext(GlobalLoaderContext)

  useEffect(() => {
    const handleErrorMessageFromBackend = (error: unknown) => {
      if (isErrorWithViewMessage(error)) {
        if (error?.data) {
          const { data } = error
          if (data && data.view_message) {
            showNotification(NotificationType.ERROR, data.view_message)
          }
        }
      }
    }

    const handleErrorResponse = (error: unknown) => {
      if (isErrorWithResponse(error)) {
        const { status: statusCode } = error.response
        if (statusCode === 498 && CookieService.getItem()) {
          showNotification(
            NotificationType.INFO,
            'Skończyła się Twoja sesja, zaloguj się jeszcze raz'
          )
          showLoader(true, 'Przekierowuję do ekranu logowania...')
          CookieService.removeItem()
          setTimeout((): void => {
            window.location.replace('/')
          }, 2000)
        }
      }
    }

    const updateTokenFromResponse = (response: unknown) => {
      if (isResponseWithToken(response)) {
        const { expirationDate, token } = response.data
        CookieService.setItem(token, new Date(expirationDate))
        const { user } = parseJwt(token)
        userContext.updateUser(UserDtoToFrontAdapter(user))
      }
    }

    const myInterceptor = AxiosBackend.interceptors.response.use(
      (response) => {
        updateTokenFromResponse(response)
        return response
      },
      (error: unknown): Promise<void> => {
        handleErrorMessageFromBackend(error)
        handleErrorResponse(error)
        return Promise.reject(error)
      }
    )

    return () => {
      AxiosBackend.interceptors.response.eject(myInterceptor)
    }
  }, [])
}
